import { useMutation, useQueryClient } from "react-query";
import { del } from "../../../../http";
import { savedExortSettings } from "../../bulkBaseUrl";
import { favouriteItemsKey } from "../../../../favourites/api";
import { subscriptionItemsKey, subscriptionsBaseApiUrl } from "../../../../subscriptions/api";

export function useDeleteBulkExportStateMutation() {
  const queryClient = useQueryClient();
  const { isLoading, isError, isSuccess, mutate } = useMutation((id: number) => deleteExportSettings(id), {
    onSettled: () => {
      queryClient.invalidateQueries(favouriteItemsKey);
      queryClient.invalidateQueries(subscriptionItemsKey);
    },
  });
  return {
    isDeleteBulkExportSettingsLoading: isLoading,
    isDeleteBulkExportSettingsError: isError,
    isdeleteBulkExportSettingsSuccess: isSuccess,
    deleteBulkExportSettings: mutate,
  };
}

async function deleteExportSettings(id: number) {
  try {
    const url = savedExortSettings + `/${id}`;
    await del(url, {
      headers: {
        Accept: "*/*",
      },
    });
    await del(`${subscriptionsBaseApiUrl}/SubscriptionManagement/subscriptionsForSavedBulkExport/${id}`);
  } catch (err) {
    console.error(err);
  }
}
